import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { init as initPWA } from './registerServiceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Regista o Service Worker (offline, prompt de instalação e aviso de nova
// versão). Estava escrito desde sempre mas nunca chegava a ser chamado, o
// que deixava a app instalável mas sem nada disto a funcionar.
initPWA();

reportWebVitals();
